export const environment = {
  production: false,
  pulseWizardStateDebugOverlay: true,
  dbJsonConfigFile: 'db_reports.test.json',
  apiBaseUrl: '',
  dcEnvironments: ['test'],
  dscoEnvironments: ['test', 'staging'],
  orderstreamEnvironments: ['lchan'],
  rtbfEnvironments: ['dev'],
  pulseEnvironments: ['test', 'dev'],
  pulseCupAdapterEnvironments: ['test'],
  pulseOSAdapterEnvironments: ['dev'],
  searchBuckets: [
    { locationName: 'arcfs-archive', locationType: 'bucket', locationDisplayName: 'ArcFS Archive' },
    { locationName: 'arcfs-archive24', locationType: 'bucket', locationDisplayName: 'ArcFS Archive 24' },
    { locationName: 'livefs-archive24', locationType: 'bucket', locationDisplayName: 'LiveFS Archive 24' },
  ],
  optiksEnvironments: ['test', 'staging'],
  notificationServiceEnvironments: ['dev', 'test'],
};
